module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"ui":{"components":{"start":{"notifications":{"button":"Alle Mitteilungen ansehen","description":"Die neusten Mitteilungen auf einen Blick","title":"Mitteilungen"}}}}}}')
  delete Component.options._Ctor
}
